export function getAssetUrl(path) {
  return `${process.env.REACT_APP_COMMUNITIES_CDN_URL}${path}`;
}

export const EMOJI_REGEXP =
  /^((?!((\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]))).)*$/gm;

export const SCRIPT_REGEXP = /^((?!<script.*>((.|\n)*)<\/script>).)*$/i;
